var paymentMethodTypes = {
  APPLE_PAY: 'applePay',
  APPLE_PAY_EXPRESS: 'applePayExpress',
  CARD: 'card',
  EXPRESS_ELIGIBLE: 'expressEligible',
  GOOGLE_PAY: 'googlePay',
  KLARNA: 'klarna'
};
export { paymentMethodTypes as default };